export default __webpack_public_path__ + "static/media/IMG_4471.f876ef68.jpg";